import React, { Component } from 'react';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import { map, findIndex, cloneDeep, isEqual } from 'lodash';
import Button from '../common/Button';
import PageLoader from '../common/PageLoader';
import EmptyState from '../EmptyState/EmptyState';
import { imageBasePath } from '../../constants/staticData';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';

class CheckboxGroup extends Component {
  constructor(props) {
    super(props);
    let check = findIndex(props.data, (brand) => {
      return brand.status == 0 || brand.status == null;
    });
    this.state = {
      isButtonLoading: false,
      clickedTab: '',
      showModal: false,
      SToggleSwitch: check == -1 ? true : false,
      manufacturers: props.data
    };
    this.handleTabSwitch = this.handleTabSwitch.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.commonReducer.hideButtonLoader && this.state.isButtonLoading) {
      // this.props.actions.hideToastMessage();
      this.setState({ 'isButtonLoading': false });
      if ((nextProps.serviceType == 'manufactures' && !nextProps.vendorProfileReducer.garageServicesError.manufacturerError) && nextProps.buttonLabel == 'Next') {
        this.props.btnCallBack();
      }
    }
    if (!this.state.manufacturers) {
      let check = findIndex(nextProps.data, (brand) => {
        return brand.status == 0 || brand.status == null;
      });
      this.setState({ manufacturers: nextProps.data, SToggleSwitch: check == -1 ? true : false });
    }
  }
  handleCheck(categoryIndex, type) {

    let boxData = cloneDeep(this.state.manufacturers);
    let index = findIndex(boxData, { id: categoryIndex });
    if (index != -1) {
      boxData[index].status = type.target.checked ? 1 : 0;
    }
    let check = findIndex(boxData, (service) => {
      return service.status == 0 || service.status == null;
    });

    this.setState({ manufacturers: boxData, SToggleSwitch: check == -1 ? true : false });
  }

  changeToggle() {
    let boxData = cloneDeep(this.state.manufacturers);
    map(boxData, (service, key) => {
      boxData[key].status = !this.state.SToggleSwitch ? 1 : 0;
    });
    this.setState({ manufacturers: boxData, SToggleSwitch: !this.state.SToggleSwitch });
  }

  handleTabSwitch(tabName) {
    if (!isEqual(this.props.data, this.state.manufacturers)) {
      this.setState({ showModal: true, clickedTab: tabName });
    } else {
      this.props.tabClickSwitch(tabName);
    }
  }

  render() {
    const { btnCallBack, router, buttonLabel, actions, hide, data, isLoaded } = this.props;
    return (
      <div className={hide ? 'hide checkbox-group' : 'checkbox-group'}>
        <div className="text-holder">
          <p>Choose the manufacturers you support.</p>
          {data && data.length ? <span className="toggle-switch toggleBtn s-selection-box">
            <span>Select All</span>
            <ToggleSwitch
              checked={this.state.SToggleSwitch}
              onChange={() => this.changeToggle()}
              size="small"
            />
          </span> : ''}
        </div>
        <div className="checkbox-holder">
          {isLoaded ? data && data.length ? map(this.state.manufacturers, (manufacturers, index) => {
            return (
              <div className="checkbox checkbox-style" key={index}>
                <input type="checkbox" checked={manufacturers.status} id={index} onChange={(checked) => { this.handleCheck(manufacturers.id, checked); }} />
                <label htmlFor={index} className="ms-checkbox-label" >{manufacturers.name}</label>
              </div>
            );
          })
            : <EmptyState image={`${imageBasePath}/empty_service.png`} message={'This Service is Currently unavailable'} /> : <PageLoader />}

        </div>
        {data && data.length ? <span className="ms-button">
          <Button btnType="red" btnSize="sm" fontSize={15} label={buttonLabel} btnCallBack={() => {
            if (findIndex(this.state.manufacturers, { status: 1 }) == -1) {
              actions.showToastMessage('Please select supported Manufacturers', 'error');
            } else {
              this.setState({ isButtonLoading: true });
              actions.addManufacturers(this.state.manufacturers, router, buttonLabel == "Save" ? '' : 'overview');
            }

            // buttonLabel == 'Next' && btnCallBack();
          }
          }
            isButtonLoading={this.state.isButtonLoading}
          />
        </span> : ''}
        <CustomModal className="decline-modal" showModal={this.state.showModal} footer="true" title="Save Changes" hideModal={() => this.setState({ showModal: false })} saveText="Save" submitCallBack={() => {
          if (findIndex(this.state.manufacturers, { status: 1 }) == -1) {
            actions.showToastMessage('Please select supported Manufacturers', 'error');
          } else {
            actions.addManufacturers(this.state.manufacturers, router, buttonLabel == "Save" ? '' : 'overview');
            this.props.tabClickSwitch(this.state.clickedTab);
          }
          this.setState({ showModal: false });
        }}>
          <Modal.Body>
            <div>
              <span className="caption-result">Do you want to save the changes you just made?</span>
            </div>
          </Modal.Body>
        </CustomModal>
      </div>
    );
  }
}

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/ManageServices/CheckboxGroup.jsx